module.exports = __webpack_public_path__ + "static/media/human-advantage-minus.15c447bd.svg";